import React, { FC } from "react";
import { FeaturedDoctor } from "./FeaturedDoctor.csharp";

interface FeaturedDoctorCardProps {
  doctor: FeaturedDoctor;
  backgroundColor?: string;
}

export const FeaturedDoctorCard: FC<FeaturedDoctorCardProps> = ({
  doctor,
  backgroundColor,
}) => {
  return (
    <div className="card card-hover theme-inherit-light featuredDoctorCard">
      <div
        className="card-body d-block"
        style={{ backgroundColor: backgroundColor }}
      >
        <img
          className="circular-image medium mb-3"
          src={
            doctor.imageUrl +
            "?width=216&height=216&rmode=crop&ranchor=top"
          }
          alt=""
        />
        <h3 className="h5">
          <a className="card-block-link" href={doctor.url}>
            {doctor.name}
          </a>
        </h3>
        <p
          className="fw-bold text-break"
          dangerouslySetInnerHTML={{ __html: doctor.jobTitle }}
        />
        <p>{doctor.centers.join(", ")}</p>
      </div>
    </div>
  );
};
